import Colors from 'common/ui/Colors';

export const WELL_FILL = Colors.GREY_40;
export const WELL_STROKE = Colors.GREY_80;
export const PLATE_FILL = Colors.GREY_10;
export const PLATE_STROKE = Colors.GREY_40;
